var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import '../../components/wui-text/index.js';
import '../../components/wui-image/index.js';
import '../../layout/wui-flex/index.js';
import { elementStyles, resetStyles } from '../../utils/ThemeUtil.js';
import { customElement } from '../../utils/WebComponentsUtil.js';
import styles from './styles.js';
import { UiHelperUtil } from '../../utils/UiHelperUtil.js';
import { W3mFrameRpcConstants } from '@web3modal/wallet';
import { AccountController, BlockchainApiController, NetworkController, StorageUtil } from '@web3modal/core';
let WuiListAccount = class WuiListAccount extends LitElement {
    constructor() {
        super(...arguments);
        this.accountAddress = '';
        this.accountType = '';
        this.connectedConnector = StorageUtil.getConnectedConnector();
        this.labels = AccountController.state.addressLabels;
        this.caipNetwork = NetworkController.state.caipNetwork;
        this.balance = 0;
        this.fetchingBalance = true;
        this.shouldShowIcon = false;
        this.selected = false;
    }
    connectedCallback() {
        super.connectedCallback();
        BlockchainApiController.getBalance(this.accountAddress, this.caipNetwork?.id).then(response => {
            let total = this.balance;
            if (response.balances.length > 0) {
                total = response.balances.reduce((acc, balance) => acc + (balance?.value || 0), 0);
            }
            this.balance = total;
            this.fetchingBalance = false;
            this.requestUpdate();
        });
    }
    render() {
        const label = this.getLabel();
        this.shouldShowIcon = this.connectedConnector === 'AUTH';
        return html `
      <wui-flex
        flexDirection="row"
        justifyContent="space-between"
        .padding=${['0', '0', 's', '1xs']}
      >
        <wui-flex gap="md" alignItems="center">
          <wui-avatar address=${this.accountAddress}></wui-avatar>
          ${this.shouldShowIcon
            ? html `<wui-icon-box
                size="sm"
                iconcolor="fg-200"
                backgroundcolor="fg-300"
                icon=${this.accountType === W3mFrameRpcConstants.ACCOUNT_TYPES.EOA
                ? 'mail'
                : 'lightbulb'}
                background="fg-300"
              ></wui-icon-box>`
            : html `<wui-flex .padding="${['0', '0', '0', 's']}"></wui-flex>`}
          <wui-flex flexDirection="column">
            <wui-text class="address" variant="paragraph-500" color="fg-100"
              >${UiHelperUtil.getTruncateString({
            string: this.accountAddress,
            charsStart: 4,
            charsEnd: 6,
            truncate: 'middle'
        })}</wui-text
            >
            <wui-text class="address-description" variant="small-400">${label}</wui-text></wui-flex
          >
        </wui-flex>
        <wui-flex gap="s" alignItems="center">
          ${this.fetchingBalance
            ? html `<wui-loading-spinner size="sm" color="accent-100"></wui-loading-spinner>`
            : html ` <wui-text variant="small-400">$${this.balance.toFixed(2)}</wui-text>`}
          <slot name="action"></slot>
        </wui-flex>
      </wui-flex>
    `;
    }
    getLabel() {
        let label = this.labels?.get(this.accountAddress);
        if (!label && this.connectedConnector === 'AUTH') {
            label = `${this.accountType === 'eoa' ? 'Email' : 'Smart'} Account`;
        }
        else if ((!label && this.connectedConnector === 'INJECTED') ||
            this.connectedConnector === 'ANNOUNCED') {
            label = `Injected Account`;
        }
        else if (!label) {
            label = 'EOA';
        }
        return label;
    }
};
WuiListAccount.styles = [resetStyles, elementStyles, styles];
__decorate([
    property()
], WuiListAccount.prototype, "accountAddress", void 0);
__decorate([
    property()
], WuiListAccount.prototype, "accountType", void 0);
__decorate([
    property({ type: Boolean })
], WuiListAccount.prototype, "selected", void 0);
__decorate([
    property({ type: Function })
], WuiListAccount.prototype, "onSelect", void 0);
WuiListAccount = __decorate([
    customElement('wui-list-account')
], WuiListAccount);
export { WuiListAccount };
//# sourceMappingURL=index.js.map